import { inject, Pipe, PipeTransform } from '@angular/core';
import { getPdfUriForDocument } from '@zero/postbox/util-helper';
import { Post } from '@zero/shared/util-models';
import { DataService } from '@zero/shared/util-web-app-services';

@Pipe({
  name: 'pdfUri',
  standalone: true,
})
export class PdfUriPipe implements PipeTransform {
  readonly #dataService = inject(DataService);

  public transform(document: Post): string {
    return getPdfUriForDocument(document, this.#dataService.getSelectedCustomer());
  }
}
